import chroma from 'chroma-js';

export default function getOffsetColor(
  color = '#000',
  hard = false,
  factor = 3.5,
) {
  if (!color) {
    return '#FFFFFF';
  }

  const luminance = chroma(color).get('hsl.l');

  if (luminance >= 0.5 && hard) {
    return '#000000';
  }

  if (luminance < 0.5 && hard) {
    return '#FFFFFF';
  }

  if (luminance >= 0.5) {
    return chroma(color).darken(factor).hex();
  }

  if (luminance < 0.5) {
    return chroma(color).brighten(factor).hex();
  }

  return '#FFFFFF';
}
